export function formatError(error) {
  let { path, message } = error || {};

  if (!message) {
    message = 'Sorry, Please try again later';
  }

  if (path && Array.isArray(path)) {
    // return {
    //   [path]: message
    // };

    return {
      message
    };
  }

  return {
    message
  };
}

export function getErrors(err) {
  if (err.response) {
    const { data } = err.response;
    const { error } = data || {};
    const { errors } = error || {};

    if (errors && Array.isArray(errors)) {
      return formatError(errors[0]);
    }

    return formatError(error);
  }

  return formatError(err);
}
